import Typography from '@mui/material/Typography';
import { ReferenceField } from 'react-admin';

import { SupplierAvatar } from '../suppliers/SupplierAvatar';
import type { ActivityDealNoteCreated } from '../types';
import { BuyerName } from '../buyers/BuyerName';
import { RelativeDate } from '../misc/RelativeDate';
import { ActivityLogNote } from './ActivityLogNote';
import { useActivityLogContext } from './ActivityLogContext';

type ActivityLogDealNoteCreatedProps = {
    activity: ActivityDealNoteCreated;
};

export function ActivityLogDealNoteCreated({
    activity,
}: ActivityLogDealNoteCreatedProps) {
    const context = useActivityLogContext();
    const { dealNote } = activity;
    return (
        <ActivityLogNote
            header={
                <>
                    <ReferenceField
                        source="deal_id"
                        reference="deals"
                        record={dealNote}
                        link={false}
                    >
                        <ReferenceField
                            source="id_pessoa"
                            reference="persons"
                            link={false}
                        >
                            <SupplierAvatar width={20} height={20} />
                        </ReferenceField>
                    </ReferenceField>
                    <Typography
                        component="p"
                        variant="body2"
                        color="text.secondary"
                        flexGrow={1}
                    >
                        <ReferenceField
                            source="sales_id"
                            reference="salespersons"
                            record={activity}
                            link={false}
                        >
                            <BuyerName />
                        </ReferenceField>
                        {dealNote.nome_usuario}{' '}
                        comentou no deal{' '}
                        <ReferenceField
                            source="deal_id"
                            reference="deals"
                            record={dealNote}
                            link="show"
                        />
                        {context !== 'company' && (
                            <>
                                {' de '}
                                <ReferenceField
                                    source="deal_id"
                                    reference="deals"
                                    record={dealNote}
                                    link={false}
                                >
                                    <ReferenceField
                                        source="id_pessoa"
                                        reference="persons"
                                        link="show"
                                    />
                                </ReferenceField>{' '}
                                <RelativeDate date={activity.data_hora} />
                            </>
                        )}
                    </Typography>
                    {context === 'company' && (
                        <Typography
                            color="textSecondary"
                            variant="body2"
                            component="span"
                        >
                            <RelativeDate date={activity.data_hora} />
                        </Typography>
                    )}
                </>
            }
            text={dealNote.texto_atividade}
        />
    );
}
